<template>
  <div class="pageContent">
    <selectPatients :patientList="patientList" />
  </div>
</template>
<script>
import selectPatients from '@/components/selectPatient/index'
import { patientList } from '@/api/check'
import Storage from '@/tools/storage'
export default {
  name: 'selectPatient',
  components: { selectPatients },
  data() {
    return {
      patientList: []
    }
  },
  methods: {
    async getPatientList() {
      let params = { phone: Storage.get('phone'), institution_id: '13000003' }
      let res = await patientList(params)
      if (res) {
        this.patientList = res
      }
    }
  },
  mounted() {
    this.getPatientList()
  }
}
</script>
<style lang="scss" scoped>
</style>
